import UAParser from 'ua-parser-js';

export default () => {
  const parser = new UAParser();
  let properties = {
    browser: parser.getBrowser().name,
    device: parser.getDevice().type || 'pc',
  };
  return properties;
};
